import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3acb4eb0")

_pushScopeId("data-v-3acb4eb0")
const _hoisted_1 = { class: "d-flex justify-space-between pa-4" }
const _hoisted_2 = { class: "d-flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "iconfont iconreport-icon-wendu title-icon" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "℃", -1)
const _hoisted_5 = { class: "value" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(_toDisplayString(_ctx.$t("temperature")) + " ", 1 /* TEXT */),
          _hoisted_4
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(Math.min(...$props.yAxis)) + "-" + _toDisplayString(Math.max(...$props.yAxis)), 1)
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, { class: "px-4" }, {
        default: _withId(() => [
          _createVNode("div", {
            ref: $setup.setRef,
            style: {"height":"60vw","width":"100%"}
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})